export const pythondata = [
    {
        "id":"1",
        "link": "https://i.ibb.co/f0L07B1/python-1.jpg"
    },
    {
        "id":"2",
        "link": "https://i.ibb.co/8NKSmgh/python-2.jpg"
    },
    {
        "id":"3",
        "link": "https://i.ibb.co/cbW4Yxq/Untitled-1.jpg"
    },
    {
        "id":"4",
        "link": "https://i.ibb.co/ftts5PW/python-3.jpg"
    }
] 

export const kraitdata = [
    {
        "id":"1",
        "link": "https://i.ibb.co/p1Yq5Yg/krait-1-Copy.jpg"
    },
    {
        "id":"2",
        "link": "https://i.ibb.co/C7q6WXs/krait-1.jpg"
    },
    {
        "id":"3",
        "link": "https://i.ibb.co/CzhnMv1/krait-2.jpg"
    },
    {
        "id":"4",
        "link": "https://i.ibb.co/SVMLxtd/krait3.jpg"
    }
]